import { Component, EventEmitter, Inject, Input, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { ResetPinOtpService } from '../../core/services/reset-pin-otp.service';
import { UiHelperService } from '../../services/ui-helper.service';

export interface TokenFisicoValidateOtpModalData {
  transactionId: string;
  /** Segundos hasta que expire el OTP (ej. 300 = 5 min). */
  expiresInSeconds: number;
  channel: 'email';
  /** Destino enmascarado para mostrar (ej. XXXXXXXEBA23@GMAIL.COM). */
  maskedDestination: string;
}

export interface TokenFisicoValidateOtpModalResult {
  validated: true;
}

@Component({
  selector: 'app-token-fisico-validate-otp-modal',
  templateUrl: './token-fisico-validate-otp-modal.component.html',
  styleUrls: ['./token-fisico-validate-otp-modal.component.css'],
  standalone: false
})
export class TokenFisicoValidateOtpModalComponent {
  validating = false;
  validateError: string | null = null;

  @Input() embedded = false;
  @Input() embeddedData: TokenFisicoValidateOtpModalData | null = null;

  @Output() embeddedCancel = new EventEmitter<void>();
  @Output() embeddedResult = new EventEmitter<TokenFisicoValidateOtpModalResult>();

  constructor(
    @Optional() public dialogRef: MatDialogRef<TokenFisicoValidateOtpModalComponent> | null,
    @Optional() @Inject(MAT_DIALOG_DATA) public injectedData: TokenFisicoValidateOtpModalData | null,
    private resetPinOtpService: ResetPinOtpService,
    private uiHelper: UiHelperService
  ) {}

  get otpData(): TokenFisicoValidateOtpModalData {
    const d = this.embeddedData ?? this.injectedData;
    if (!d) {
      throw new Error('TokenFisicoValidateOtpModal: faltan datos.');
    }
    return d;
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.embeddedCancel.emit();
    }
  }

  onSubmit(event: { code: string }): void {
    this.validateError = null;
    this.validating = true;
    this.uiHelper.showSpinner('Validando código de verificación…', 'admin');
    this.resetPinOtpService.validateOtp(this.otpData.transactionId, event.code).pipe(
      finalize(() => {
        this.validating = false;
        this.uiHelper.hideSpinner();
      })
    ).subscribe({
      next: () => {
        const result = { validated: true as const };
        if (this.dialogRef) {
          this.dialogRef.close(result);
        } else {
          this.embeddedResult.emit(result);
        }
      },
      error: (err) => {
        this.validateError = err?.message || 'No se pudo validar el código.';
      }
    });
  }
}
